export default __webpack_public_path__ + "static/media/inn-single-supplier.84e86fb1.png";